/**
 * Class representing ReportService
 * @memberOf services.report
 * @ngdoc service
 * @name ReportService
 */
class ReportService {

  constructor($http) {
    /**
     * @type {service}
     * @memberOf ReportService
     * @description Instance of Angular $http service
     */
    this.$http = $http;
  }

  /**
   * @memberOf ReportService
   * @description Gets all available reports in the system
   */
  getAll() {
    return this.$http.get('/api/report').then(result => result.data);
  }

  /**
   * @memberOf ReportService
   * @description Gets report by mongoDB ObjectID
   * @param {ObjID} id ObjectId of the report to get
   */
  getById(id) {
    return this.$http.get('/api/report/' + id).then(result => result.data);
  }

  /**
   * @memberOf ReportService
   * @description Gets all reports associated with a given user
   * @param {ObjId} userId ObjectId of the user currently logged in
   */
  getByUser(userId) {
    return this.$http.get('/api/report/byUser/' + userId).then(result => result.data);
  }
  /**
   * @memberOf ReportService
   * @description Gets report by encrypted rkey
   * @param {string} rkey
   */
  // getByRkey(rkey) {
  //   return this.$http.get('/api/report/getByRKey/' + rkey).then(result => result.data);
  // }

  /**
   * @memberOf ReportService
   * @param {ObjId} id ObjectId of the report to be generated
   * @description Posts to generate a pdf of report based on id
   * @returns Result from $http post
   */
  postForPdf(id) {
    return this.$http.post('/api/report/' + id + '/download').then(result => result.data);
  }

  getPdf(id) {
    return this.$http.get(`/api/report/${id}/download`, { responseType: 'arraybuffer' }).then(result => result.data);
  }

    postReportAction(isOpen, sectionTitle, rkey) {
        return this.$http.post('api/report/logAction/' + isOpen + '/' + encodeURIComponent(sectionTitle) + '/' + rkey).then(result => result.data);
    }

  /**
   * @memberOf ReportService
   * @param {ObjId} ObjectId of the report to be updated
   * @param {report} Updated report object
   * @description Put to update report object`
   * @returns result from $http PUT
   */
  // update(id, report) {
  //   return this.$http.put('/api/report/' + id, report).then(result => result.data);
  // }
}

export default angular.module('services.report', [])
  .service('ReportService', ReportService)
  .name;

ReportService.$inject = ['$http'];



// WEBPACK FOOTER //
// ./src/client/app/services/report.service.js